import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';
import * as i1 from '@angular/common/http';
import * as i1$1 from '@ngrx/store';
import { select } from '@ngrx/store';
import { Subject } from 'rxjs/internal/Subject';
import { getStepDetails } from 'visa-store';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import * as i3 from 'ngx-toastr';
import * as i4 from 'app-services-library';

class APIDigitalSignature {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getSignatureInfo(visaType, caseType, caseId, docType) {
        return this.httpClient.get(`/${visaType}/${caseType}/${caseId}/${docType}/signatureInfo`).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    postSignatureInfo(visaType, caseType, caseId, docType, payload) {
        return this.httpClient.post(`/${visaType}/${caseType}/${caseId}/${docType}/signatureInfo`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
}
APIDigitalSignature.ɵfac = function APIDigitalSignature_Factory(t) { return new (t || APIDigitalSignature)(i0.ɵɵinject(i1.HttpClient)); };
APIDigitalSignature.ɵprov = i0.ɵɵdefineInjectable({ token: APIDigitalSignature, factory: APIDigitalSignature.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(APIDigitalSignature, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class BaseDigitalSignatureLibraryService {
    constructor(store, apiService, toastr, appServicesLibraryService) {
        this.store = store;
        this.apiService = apiService;
        this.toastr = toastr;
        this.appServicesLibraryService = appServicesLibraryService;
        this.observableSubscription$ = new Subject();
        this.digiSignarture = {};
        this.selectedSignatures = [];
        this.disabledControls = false;
        this.digiSignarture.isRequired = false;
        this.digiSignarture.signatureInfo = [];
        //  response.filter(ele => ele.code !== 'RFE');
    }
    loadInit() {
        var _a;
        // Get Specific step details by passing step code
        if ((_a = this.primaryData) === null || _a === void 0 ? void 0 : _a.stepId) {
            this.store.pipe(select(getStepDetails, { id: this.primaryData.stepId })).subscribe((data) => {
                this.stepDetails = data;
                this.toggleControlsStatus();
            });
        }
        this.setSignatureCapturedForValue();
        this.getSignatureInfo();
    }
    //Toggle controls status based on step status
    toggleControlsStatus() {
        this.disabledControls = this.appServicesLibraryService.formToBeDisabled(this.stepDetails.stepStatusDetails.stepStatusCode);
        // this.disabledControls =  this.stepDetails.stepStatusDetails.stepStatusCode === "NEW" || this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" || this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT" ? true : false;
    }
    setSignatureCapturedForValue() {
        switch (this.docType) {
            case 'USCISFORMS':
                this.signatureCapturedFor = 'generated form';
                break;
            case 'COVLTR':
                this.signatureCapturedFor = 'cover letter';
                break;
            case 'SUPLTR':
                this.signatureCapturedFor = 'support letter';
                break;
            default:
                this.signatureCapturedFor = '';
                break;
        }
    }
    handleSignatureSelection(value) {
        if (!value) {
            this.selectedSignatures = [];
            this.handleSaveSignatureInfo();
        }
        //  console.log(this.digiSignarture.isRequired);
        // if (value) {
        //  this.digiSignarture.isRequired = true;
        // } else {
        //  this.digiSignarture.isRequired = false;
        // }
    }
    handleSaveSignatureInfo() {
        // const payload = {
        //   ... this.digiSignarture.signatureInfo,
        //   required: this.selectedSignatures.
        // }
        const payload = this.digiSignarture.signatureInfo.map((item) => {
            if (this.selectedSignatures.find(selecteditem => selecteditem.code === item.code)) {
                item.required = true;
            }
            else {
                item.required = false;
            }
            return item;
        });
        //  console.log("this.selectedSignatures inside save",payload,this.digiSignarture.signatureInfo,this.selectedSignatures);
        this.apiService.postSignatureInfo(this.primaryData.visatype, this.primaryData.caseType, this.primaryData.caseId, this.docType, payload).pipe(takeUntil(this.observableSubscription$)).subscribe(response => {
            this.toastr.success(response.message, 'Success');
            this.getSignatureInfo();
        });
    }
    getSignatureInfo() {
        this.apiService.getSignatureInfo(this.primaryData.visatype, this.primaryData.caseType, this.primaryData.caseId, this.docType).subscribe((response) => {
            if (response && response['data']) {
                this.digiSignarture.signatureInfo = response['data'];
                this.selectedSignatures = this.digiSignarture.signatureInfo.filter(item => item.required === true);
                if (this.selectedSignatures && this.selectedSignatures.length > 0) {
                    this.digiSignarture.isRequired = true;
                }
                else {
                    this.digiSignarture.isRequired = false;
                }
            }
            else {
                this.digiSignarture.signatureInfo = [];
            }
            // console.log("this.digiSignarture.isRequired", this.digiSignarture.isRequired)
        });
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
BaseDigitalSignatureLibraryService.ɵfac = function BaseDigitalSignatureLibraryService_Factory(t) { return new (t || BaseDigitalSignatureLibraryService)(i0.ɵɵinject(i1$1.Store), i0.ɵɵinject(APIDigitalSignature), i0.ɵɵinject(i3.ToastrService), i0.ɵɵinject(i4.AppServicesLibraryService)); };
BaseDigitalSignatureLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: BaseDigitalSignatureLibraryService, factory: BaseDigitalSignatureLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseDigitalSignatureLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$1.Store }, { type: APIDigitalSignature }, { type: i3.ToastrService }, { type: i4.AppServicesLibraryService }]; }, null); })();

/*
 * Public API Surface of base-digital-signature-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { APIDigitalSignature, BaseDigitalSignatureLibraryService };
//# sourceMappingURL=base-digital-signature-library.js.map
